



import { computed, defineComponent, PropType } from '@vue/composition-api';
import apexchart from 'vue-apexcharts';
import { isNil } from 'ramda';

export default defineComponent({
    name: 'LineChart',
    props: {
        series: { type: Array as PropType<{ name: string; data: number[] }[]>, default: () => [] },
        xaxis: {
            type: Object as PropType<{
                categories: string[];
                title?: { text: string };
            }>,
            required: false,
        },
        yaxis: {
            type: Array as PropType<
                {
                    categories: string[];
                    title?: { text: string };
                    opposite?: boolean;
                    labels?: any;
                }[]
            >,
            required: false,
        },
        title: {
            type: Object as PropType<{
                text: string;
                align: string;
            }>,
            required: false,
        },
        details: {
            type: Object as PropType<{
                zoom?: { enabled?: boolean; allowMouseWheelZoom?: boolean };
                markers?: number;
                stroke?: { curve?: string; width?: number };
                legend?: { show?: boolean; position?: string };
            }>,
            required: false,
        },
        lineColours: {
            type: Array as PropType<string[]>,
            default: () => ['#2f8aa1', '#8d9f58', '#a93054', '#90775e', '#e54e42', '#e49524', '#6c9dc3'],
        },
    },
    components: { apexchart },
    setup(props: any, { emit }: { emit: any }) {
        const details: {
            chart: { zoom: { enabled: boolean; allowMouseWheelZoom: boolean } };
            markers: number;
            stroke: { curve: string; width: number };
            legend: { show: boolean; position: string };
        } = {
            chart: {
                zoom: {
                    enabled: props.details?.zoom?.enabled ?? true,
                    allowMouseWheelZoom: props.details?.zoom?.allowMouseWheelZoom ?? true,
                },
            },
            markers: props.details?.markers || 0,
            stroke: {
                curve: props.details?.stroke?.curve || 'straight',
                width: !isNil(props.details?.stroke?.width) ? props.details.stroke.width : 2,
            },
            legend: {
                show: props.details?.legend?.show || true,
                position: props.details?.legend?.position || 'bottom',
            },
        };
        const options = computed(() => {
            const chartOptions: {
                chart?: { zoom: { enabled: boolean; allowMouseWheelZoom: boolean } };
                title?: { text: string; align?: string };
                xaxis?: { categories?: string[]; title?: { text: string } };
                yaxis?: { categories?: string[]; title?: { text: string }; opposite?: boolean; labels?: any }[];
                markers: { size: number };
                stroke: { curve: string; width: number };
                legend: { show: boolean; position: string };
                colors: string[];
            } = {
                chart: details.chart,
                markers: {
                    size: details.markers,
                },
                stroke: details.stroke,
                legend: details.legend,
                colors: props.lineColours,
            };
            if (props.xaxis) chartOptions.xaxis = props.xaxis;
            if (props.yaxis) chartOptions.yaxis = props.yaxis;

            if (props.title) chartOptions.title = props.title;
            return chartOptions;
        });

        const chartClickEvent = (event: Event, chartContext: any, config: any) => {
            if (config.seriesIndex >= 0 && config.dataPointIndex >= 0)
                emit('data-point-clicked', { series: config.seriesIndex, dataPoint: config.dataPointIndex });
        };

        return { options, chartClickEvent };
    },
});
